@if (form) {
  <div [formGroup]="form">
    <div class="row">
      @if (form.value.identifier) {
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg':'col-lg-4'">
          <label>{{'administration.sectionsManagement.code' | translate}}</label>
          <apc-form-input [disabled]="true" [class]="'form-control autogenerated'" formControlName="code" type="text">
          </apc-form-input>
        </div>
      }
      <div class="form-group" [ngClass]="form.value.identifier ? 'col-lg' : 'col-lg-6'">
        <label>{{'administration.sectionsManagement.value' | translate}} *</label>
        <apc-form-input [class]="'form-control'" formControlName="name" type="text"></apc-form-input>
      </div>
    </div>
  </div>
}